/**
 * API Action Creators for Customer Vehicles
 * Contains actions that make API calls (side effects / async thunks).
 */
import { RSAA } from 'redux-api-middleware';
import { FETCH_TRADE_INS_REQUEST, FETCH_TRADE_INS_SUCCESS, FETCH_TRADE_INS_FAILURE } from './actions';
import type { DealIdentifier } from '../types';
import type { RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { apiConfigHelper, locHrefUtil, SALES_CHECKIN_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
/**
 * Thunk that fetches trade-ins for one or more deals.
 * Used when landing on the page from the Customer Vehicles "Open Deal" flow,
 * where `isShowTradeInModal`, `dealXgId`, and `dealXgVersion` are set in the URL.
 *
 * Dispatches:
 *   FETCH_TRADE_INS_REQUEST  – before the fetch begins
 *   FETCH_TRADE_INS_SUCCESS  – with the raw API response as payload on success
 *   FETCH_TRADE_INS_FAILURE  – with the error message on failure
 */
export const fetchTradeInsForDeal =
    (deals: DealIdentifier[]) =>
    (dispatch: (action: any) => void): void => {
        const tradeInsSearchUrl = apiConfigHelper.buildBffApiUrl(SALES_CHECKIN_APP_PREFIX, locHrefUtil.getLocHref(), 'trades').url;
        const request: RSAACallRequest = {
            endpoint: tradeInsSearchUrl,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ deals }),
            types: [FETCH_TRADE_INS_REQUEST, FETCH_TRADE_INS_SUCCESS, FETCH_TRADE_INS_FAILURE],
            fetch: async (...args) => await fetch(...args)
        };
        dispatch({ [RSAA]: request });
    };
